import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas offcanvas-end",
  tabindex: "-1",
  id: "offcanvas",
  "aria-labelledby": "staticBackdropLabel",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = { class: "d-flex flex-fill justify-content-between align-items-center" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  class: "text-dark m-0 fw-bold",
  id: "staticBackdropLabel"
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "overflow-scroll" }
const _hoisted_9 = { class: "" }

import { computed } from 'vue';
import { EOffcanvasPage, OffCanvasPages } from './canvas.pages';

import useOffCanvas from './useOffCanvas';

export default /*@__PURE__*/_defineComponent({
  __name: 'OffcanvasComponent',
  setup(__props) {

const { topItemInStack, canvasBackPressed, closeCanvas } = useOffCanvas()
const title = computed(() => topItemInStack.value?.title || '');
const View = computed(() => {
  if (topItemInStack.value) {
    return OffCanvasPages[topItemInStack.value.key as EOffcanvasPage].component
  }
  return null
});
const viewProps = computed(() => {
  return topItemInStack.value?.props || null;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[2] || (_cache[2] = _createElementVNode("button", {
      hidden: "",
      id: `offcanvas_button`,
      type: "button",
      "data-bs-toggle": "offcanvas",
      "data-bs-target": `#offcanvas`,
      "aria-controls": "staticBackdrop"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: "fa-solid fa-arrow-left fs-2 text-dark cursor-pointer",
              style: {"left":"20px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(canvasBackPressed) && _unref(canvasBackPressed)(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(title.value), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("i", {
              class: "fa-solid fa-times text-muted fs-2 cursor-pointer",
              style: {"left":"20px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(closeCanvas) && _unref(closeCanvas)(...args)))
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(View.value), _normalizeProps(_guardReactiveProps(viewProps.value)), null, 16))
        ])
      ])
    ])
  ]))
}
}

})